module.exports = __webpack_public_path__ + "img/bg06.2324ddff.png";